import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 8h4l-2 8","key":"svg-0"}],["path",{"d":"M6 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4","key":"svg-1"}]]

const IconNumber57Small = createReactComponent('outline', 'number-57-small', 'Number57Small', __iconNode);

export default IconNumber57Small;